import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useLocalStorage } from 'react-use';
import { RESIZE_LINE_WIDTH } from '@/components/layout/SplitScreenLayout/ResizeLine';
import { useResizablePanel } from '@/components/layout/SplitScreenLayout/useResizablePanel';
import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';
import { useResizableRightPanel } from '@/hooks/useResizableRightPanel';
const SECTION_RAIL_DEFAULT_WIDTH = 220;
const SECTION_RAIL_MIN_WIDTH = 160;
const SECTION_RAIL_MAX_WIDTH = 480;
const INSPECTOR_DEFAULT_WIDTH = 610;
const INSPECTOR_MIN_WIDTH = 400;
export const CANVAS_MIN_WIDTH = 480;

/**
 * Controls the widths of the form builder's section rail and question
 * settings panel. Attach `panelsRef` to the row that holds the panels. The
 * hook keeps the user's widths in local storage across sessions.
 */
export function useFormBuilderPanelWidths() {
  const $ = _c(16);
  const panelsRef = useRef(null);
  const [storedSectionRailWidth, setStoredSectionRailWidth] = useLocalStorage(LOCAL_STORAGE_KEYS.FORM_BUILDER_SECTION_RAIL_WIDTH, SECTION_RAIL_DEFAULT_WIDTH);
  const [storedInspectorWidth, setStoredInspectorWidth] = useLocalStorage(LOCAL_STORAGE_KEYS.FORM_BUILDER_INSPECTOR_WIDTH, INSPECTOR_DEFAULT_WIDTH);
  const t0 = storedSectionRailWidth ?? SECTION_RAIL_DEFAULT_WIDTH;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      containerRef: panelsRef,
      defaultWidth: t0,
      minWidth: SECTION_RAIL_MIN_WIDTH,
      maxWidth: SECTION_RAIL_MAX_WIDTH
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sectionRail = useResizablePanel(t1);
  const t2 = storedInspectorWidth ?? INSPECTOR_DEFAULT_WIDTH;
  const t3 = sectionRail.panelWidth + CANVAS_MIN_WIDTH + 2 * RESIZE_LINE_WIDTH;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      containerRef: panelsRef,
      defaultWidth: t2,
      minWidth: INSPECTOR_MIN_WIDTH,
      minRemainingWidth: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const inspector = useResizableRightPanel(t4);
  let t5;
  let t6;
  if ($[5] !== sectionRail.panelWidth || $[6] !== setStoredSectionRailWidth) {
    t5 = () => {
      setStoredSectionRailWidth(sectionRail.panelWidth);
    };
    t6 = [sectionRail.panelWidth, setStoredSectionRailWidth];
    $[5] = sectionRail.panelWidth;
    $[6] = setStoredSectionRailWidth;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[9] !== inspector.panelWidth || $[10] !== setStoredInspectorWidth) {
    t7 = () => {
      setStoredInspectorWidth(inspector.panelWidth);
    };
    t8 = [inspector.panelWidth, setStoredInspectorWidth];
    $[9] = inspector.panelWidth;
    $[10] = setStoredInspectorWidth;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t9;
  if ($[13] !== inspector || $[14] !== sectionRail) {
    t9 = {
      panelsRef,
      sectionRail,
      inspector
    };
    $[13] = inspector;
    $[14] = sectionRail;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}